import styled, { css } from 'styled-components';

import { Section } from 'src/presentation/components/forms/Layout';
import InformationIcon from '@ad-scripts/presentation/components/common/icons/stroke/information-stroke';
import EmbedModalWithGreenHeader, {
  ContentContainer,
} from 'src/presentation/components/pages/shared/EmbedModalWithGreenHeader';
import { Footer } from '@ad-scripts/presentation/components/common/full_page_modal';

export const StyledAddModelContainer = styled.div``;

export const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.insetLarge};
  padding-top: ${({ theme }) => theme.spacing.insetLarge};
  padding: 0 ${({ theme }) => theme.spacing.insetLarge};
  & > div {
    width: 100%;
  }
`;

export const Row = styled.div`
  display: flex;
  margin-bottom: 0;
  border-radius: 5px;
  width: 100%;
`;

export const StyledRow = styled.div`
  align-items: center;
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: start;
  width: 100%;
`;

export const StyledColumn = styled.div`
  align-items: flex-start !important;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: center;
  width: 100%;
`;

export const StyledSection = styled(Section)`
  width: 100%;
`;

export const OptionalFieldMarker = styled.span`
  padding-left: ${({ theme }) => theme.spacing.insetSmall};
  color: ${({ theme }) => theme.colors.gray500};
`;

export const WarningIcon = styled(InformationIcon)`
  fill: ${p => p.theme.colors.red500};
  height: ${p => p.theme.fontSize.medium};
  min-width: ${p => p.theme.fontSize.medium};
  padding-right: ${p => p.theme.spacing.insetSmall};
  position: relative;
  top: 2px;
`;

export const AddButtonWrapper = styled.div`
  display: flex;
  padding-top: ${({ theme }) => theme.spacing.insetLarge};
`;

export const StyledEmbedModalWithGreenHeader = styled(EmbedModalWithGreenHeader)`
  ${ContentContainer} {
    padding: 24px 0 0 !important;
  }
`;

export const StyledFooter = styled(Footer)`
  border-top: 1px solid ${({ theme }) => theme.colors.gray300};
  border-radius: 0 0 ${p => p.theme.borderRadius.large} ${p => p.theme.borderRadius.large};
`;

export const relativeThreadBlockHiddenCss = css`
  visibility: hidden;
`;

export const relativeThreadBlockVisibleCss = css`
  opacity: 1;
  z-index: 1;
  visibility: visible;
`;
